/* eslint-disable camelcase */
import { createChartData, US_AND_CANADA } from './utils';

export default function filterHelper(region, chartData, filter) {
  const add = obj => Object.values(obj).reduce((a, b) => a + b, 0);
  const monthlyData = chartData.map(elem => createChartData(elem, filter));

  const {
    total_organic_search_traffic,
    total_organic_search_traffic_last_month,
    total_organic_search_traffic_value,
    total_organic_search_traffic_value_last_month,
    total_content_debit,
    total_content_debit_last_month,
    average_cpc,
    average_cpc_last_month
  } = region;

  const regionName = filter.toLowerCase();

  switch (filter) {
    case US_AND_CANADA:
      return {
        total_organic_search_traffic: add(total_organic_search_traffic),
        total_organic_search_traffic_last_month: add(total_organic_search_traffic_last_month),
        total_organic_search_traffic_value: add(total_organic_search_traffic_value),
        total_organic_search_traffic_value_last_month: add(
          total_organic_search_traffic_value_last_month
        ),
        total_content_debit,
        total_content_debit_last_month,
        average_cpc: add(average_cpc),
        average_cpc_last_month: add(average_cpc_last_month),
        monthlyData
      };
    default:
      return {
        total_organic_search_traffic: total_organic_search_traffic[regionName],
        total_organic_search_traffic_last_month:
          total_organic_search_traffic_last_month[regionName],
        total_organic_search_traffic_value: total_organic_search_traffic_value[regionName],
        total_organic_search_traffic_value_last_month:
          total_organic_search_traffic_value_last_month[regionName],
        total_content_debit,
        total_content_debit_last_month,
        average_cpc: average_cpc[regionName],
        average_cpc_last_month: average_cpc_last_month[regionName],
        monthlyData
      };
  }
}



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/filterHelper.js